import { render, staticRenderFns } from "./defra-factors.vue?vue&type=template&id=4a557208&scoped=true"
import script from "./defra-factors.vue?vue&type=script&lang=js"
export * from "./defra-factors.vue?vue&type=script&lang=js"
import style0 from "./defra-factors.vue?vue&type=style&index=0&id=4a557208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a557208",
  null
  
)

export default component.exports